
export default {
  head() {
    return {
      title: "Agence Google Ads | SEA à Paris dès 290€/mois – ALEO AGENCY",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, agence Google Ads à Paris certifiée Google Partner, accompagne les entreprises parisiennes pour accroître leurs contacts et leur chiffre d’affaires.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Agence Google Ads à Paris dès 290€/mois – ALEO AGENCY",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, agence Google Ads à Paris certifiée Google Partner, accompagne les entreprises parisiennes pour accroître leurs contacts et leur chiffre d’affaires.",
        },
      ],
    };
  },
};
